import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { IShippingOrderAssetsSort, ShippingOrderAssetsSortBy } from "../config"
import { TableColumn } from "components/Table/Table"

interface IUseShippingORderAssetsTableParams {
    isLoadingAssetDisplayStatuses: boolean
    actionsColumn?: boolean
    sort: IShippingOrderAssetsSort | null
    setSort: (sort: IShippingOrderAssetsSort | null) => void
}

export default function useShippingOrderAssetsTable({
    isLoadingAssetDisplayStatuses,
    actionsColumn,
    sort,
    setSort,
}: IUseShippingORderAssetsTableParams) {
    const { t } = useTranslation()

    const tableColumns: TableColumn[] = useMemo(() => {
        const columns: TableColumn[] = [
            {
                title: t("common.article"),
                width: "13%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.articleDescription ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.articleDescription, sortDirection }),
            },
            {
                title: t("common.lmid"),
                width: "13%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.lmid ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.lmid, sortDirection }),
            },
            {
                title: t("asset.stateOfStorage.label"),
                width: "13%",
                sort: !isLoadingAssetDisplayStatuses && sort?.sortBy === ShippingOrderAssetsSortBy.stateOfStorage ? sort.sortDirection : undefined,
                onSortChange: isLoadingAssetDisplayStatuses
                    ? undefined
                    : sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.stateOfStorage, sortDirection }),
            },
            {
                title: t("shippingOrders.fromLocation"),
                width: "20%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.fromLocation ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.fromLocation, sortDirection }),
            },
            {
                width: "4rem",
                className: "px-0",
            },
            {
                title: t("shippingOrders.toLocation"),
                width: "20%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.toLocation ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.toLocation, sortDirection }),
            },
            {
                title: t("common.startDate"),
                width: "10%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.startDate ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.startDate, sortDirection }),
            },
            {
                title: t("common.endDate"), width: "10%",
                sort: sort?.sortBy === ShippingOrderAssetsSortBy.endDate ? sort.sortDirection : undefined,
                onSortChange: sortDirection => setSort({ sortBy: ShippingOrderAssetsSortBy.endDate, sortDirection }),
            },
        ]
        if (actionsColumn) {
            columns.push({
                width: "4rem",
            })
        }
        return columns
    }, [actionsColumn, isLoadingAssetDisplayStatuses, setSort, sort, t])

    return {
        tableColumns,
    }

}
